import React, { useState, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Detail as DetailComponent, InfoHeader, useDrawer } from '../../../../mtska-frontend-app-component';
import { useDataProvider } from '../../../../mtska-frontend-data-provider';
import { AppContext, useSettingsContext } from 'src/mtska-frontend-app-scaffolding';
import { CircularProgress } from '@mui/joy';
import { Backdrop } from "@mui/material"

const dataProviderName = 'audiences/audiencesegment';
const wizardName = 'SegmentationRuleCreate';
const wizardAction = 'create';
const wizardObject = 'Lead';

const CreateSegmentationRule = (params) => {
    const { t } = useTranslation();
    const { close } = useDrawer();
    const { userCapabilities, existingModules } = useContext(AppContext);
    const { comparableFilters } = useSettingsContext();
    const [drawable, setDrawable] = useState(true);

    // DATA PROVIDER
    const {
        errorMessage,
        errors,
        saving,
        doAction,
        success
    } = useDataProvider(dataProviderName, false);

    const modelName = existingModules.modelName;

    let detailConfig = {
        "tabs": [
            {
                "name": "confirm",
                "fieldsets": [
                    {
                        "name": "confirm",
                        "fields": {
                            "confirm": {
                                "type": "select",
                                "className": "col-12",
                                "label": t("Confermi di voler creare il segmento?"),
                                "options": [{label: "true", value: "true"}, {label: "false", value: "false"}]
                            },
                            "name": {
                                "type": "text",
                                "icon": "faInputText",
                                "label": t("segmentname"),
                                "className": "col-6"
                            },
                            "color": {
                                "type": "colorpicker",
                                "icon": "faInputText",
                                "label": t("segmentColor"),
                                "className": "col-6"
                            }
                        }
                    }
                ]
            }
        ],
        "validation": []
    }

    useEffect(() => {
        if (success) {
            (async () => {
                try {
                    await params.handleClose(params.uid)
                } catch (e) {}
            })()
        }
    }, [success, params])

    const handleSave = async (data) => {
        doAction && await doAction({ action: wizardAction, model: dataProviderName, data: data });
    }

    return (
        !drawable ? <Backdrop open={!drawable} style={{ backgroundColor: "white" }}><CircularProgress /></Backdrop> :
            <DetailComponent
                values={{
                    "confirm": "true",
                    "segmentationRules": comparableFilters(params?.filterModel).items
                }}
                modelName={modelName}
                detailConfig={detailConfig}
                dataProviderName={dataProviderName}
                save={handleSave}
                saving={saving}
                errors={errors}
                errorMessage={errorMessage}
                title={t(wizardName)}
                canSave={userCapabilities && userCapabilities[dataProviderName + '.' + wizardAction.toLowerCase()]}
                header={
                    <InfoHeader
                        view="wizard"
                        title={t(wizardName)}
                        subtitle={t('Crea un segmento di audience con i filtri attualmente attivi in lista')}
                    />
                }
                {...params}
            />
    )
}

export default CreateSegmentationRule;